type OrdersSubstitutionModalProps = {
  open: boolean
  message: string
  actionLoading: boolean
  onMessageChange: (message: string) => void
  onConfirm: () => void
  onCancel: () => void
}

export const OrdersSubstitutionModal = ({
  open,
  message,
  actionLoading,
  onMessageChange,
  onConfirm,
  onCancel,
}: OrdersSubstitutionModalProps) => {
  if (!open) {
    return null
  }

  return (
    <div className="echat-modal" role="dialog" aria-modal="true" aria-labelledby="substitution-title">
      <div className="echat-modal__backdrop" onClick={onCancel} />
      <div className="echat-modal__panel">
        <h3 id="substitution-title" className="echat-modal__title">
          Предложить замену
        </h3>
        <p className="echat-modal__text">
          Опишите, какие позиции меняются и на что. Ресторан сможет принять замену, исключить позиции
          или отказаться от заявки.
        </p>
        <label className="echat-field">
          <span className="echat-field__label">Комментарий (обязательно)</span>
          <textarea
            className="echat-field__input"
            rows={4}
            maxLength={1000}
            value={message}
            onChange={(event) => onMessageChange(event.target.value)}
            placeholder="Например: филе заменим на бедро, томаты — на огурцы"
          />
        </label>
        <div className="echat-actions">
          <button
            type="button"
            className="echat-btn echat-btn--primary"
            disabled={actionLoading || message.trim().length < 10}
            onClick={onConfirm}
          >
            Отправить предложение
          </button>
          <button type="button" className="echat-btn echat-btn--ghost" disabled={actionLoading} onClick={onCancel}>
            Отмена
          </button>
        </div>
      </div>
    </div>
  )
}
